import MobileHeader from './MobileHeader'
export default MobileHeader



// WEBPACK FOOTER //
// ./src/organisms/Header/MobileHeader/index.js